var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserProfileImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_29_4989)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5377 23.9084C39.5377 27.8926 36.3078 31.1225 32.3236 31.1225C28.3394 31.1225 25.1096 27.8926 25.1096 23.9084C25.1096 19.9242 28.3394 16.6943 32.3236 16.6943C36.3078 16.6943 39.5377 19.9242 39.5377 23.9084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3236 47.9553C39.4697 47.9553 43.5869 46.112 45.4968 44.9256C46.3905 44.3704 46.8309 43.3482 46.74 42.2893C46.6159 40.8431 46.1106 39.3987 45.5961 38.253C44.9206 36.7487 43.3569 35.9318 41.7079 35.9318H22.9394C21.2904 35.9318 19.7267 36.7487 19.0511 38.253C18.5367 39.3987 18.0313 40.8431 17.9072 42.2893C17.8163 43.3482 18.2568 44.3704 19.1505 44.9256C21.0604 46.112 25.1775 47.9553 32.3236 47.9553Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5377 23.9084C39.5377 27.8926 36.3078 31.1225 32.3236 31.1225C28.3394 31.1225 25.1096 27.8926 25.1096 23.9084C25.1096 19.9242 28.3394 16.6943 32.3236 16.6943C36.3078 16.6943 39.5377 19.9242 39.5377 23.9084Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3236 47.9553C39.4697 47.9553 43.5869 46.112 45.4968 44.9256C46.3905 44.3704 46.8309 43.3482 46.74 42.2893C46.6159 40.8431 46.1106 39.3987 45.5961 38.253C44.9206 36.7487 43.3569 35.9318 41.7079 35.9318H22.9394C21.2904 35.9318 19.7267 36.7487 19.0511 38.253C18.5367 39.3987 18.0313 40.8431 17.9072 42.2893C17.8163 43.3482 18.2568 44.3704 19.1505 44.9256C21.0604 46.112 25.1775 47.9553 32.3236 47.9553Z",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_4989",
    x1: 21.5422,
    y1: 73.6492,
    x2: 72.6178,
    y2: 9.20407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FB4C32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileImg);
export default __webpack_public_path__ + "static/media/user-profile-img.4bef799c82de952cfa048bcb9eb9cc6e.svg";
export { ForwardRef as ReactComponent };